import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { RepayDigitalWalletPage } from './repay-digital-wallet.page';
import { RepayDigitalWalletPageRoutingModule } from './repay-digital-wallet-routing.module';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    RepayDigitalWalletPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [RepayDigitalWalletPage],
  exports: [RepayDigitalWalletPage]
})
export class RepayDigitalWalletPageModule {} 